module.exports = __webpack_public_path__ + "public/SiteIcons/bathModalIcon.svg?76c48c52";